<template>
  <div class="distribution-card row bg-light mx-auto p-3 rounded my-3">
    <action-button
      class="close-icon"
      i="fa fa-times color-gray-15"
      @click="onCloseDistributionDetailsButton"
    >
      &nbsp;
    </action-button>
    <div class="col-md-12 p-0">
      <icon-view
        icon="fa fa-usd-circle mt-0"
        icon-background="#FF7058"
        icon-color="#fff"
        icon-size="18px"
        title="Detalle de la Distribución de Pago"
        variant="distribution-detail"
      />
    </div>
    <div class="col-md-12 mt-3 bg-white p-3 rounded">
      <div class="distribution-headers row mx-auto px-4">
        <div class="col font-weight-bold text-black font-12">
          Grupo de Edad
        </div>
        <div class="col font-weight-bold text-black font-12">
          Número de Grant
        </div>
        <div class="col font-weight-bold text-black font-12">
          Tipo de Servicio
        </div>
        <div class="col font-weight-bold text-black font-12">Monto</div>
        <div class="col font-weight-bold text-black font-12">
          Total de la Distribución por Edad
        </div>
      </div>
      <hr class="my-3 p-0" />

      <div class="appointment-distribution mb-2">
        <div
          v-for="(item, index) in data.appointmentDistribution"
          :key="`appointment-distribution-detail-${index}`"
          class="appointment-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
        >
          <div class="col color-gray-6 font-weight-bold font-14">
            {{ ageGroup(item) }}
          </div>
          <div class="col text-black font-14">{{ grantNumber(item) }}</div>
          <div class="col text-black font-14">Cita</div>
          <div class="col color-green-money font-weight-bold font-14">
            {{ item.amount }}
          </div>
          <div class="col text-black font-14">
            {{ amountPerAgeGroup(data.appointmentDistribution) }}
          </div>
        </div>
      </div>

      <div class="intervention-plan mb-2">
        <div
          v-for="(item, index) in data.planDistribution"
          :key="`intevention-plan-distribution-detail-${index}`"
          class="intevention-plan-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
        >
          <div class="col color-gray-6 font-weight-bold font-14">
            {{ ageGroup(item) }}
          </div>
          <div class="col text-black font-14">{{ grantNumber(item) }}</div>
          <div class="col text-black font-14">Plan Intervención</div>
          <div class="col color-green-money font-weight-bold font-14">
            {{ item.amount }}
          </div>
          <div class="col text-black font-14">
            {{ amountPerAgeGroup(data.planDistribution) }}
          </div>
        </div>
      </div>

      <div class="tap-request mb-2">
        <div
          v-for="(item, index) in data.tapRequestDistribution"
          :key="`tap-request-distribution-detail-${index}`"
          class="tap-request-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
        >
          <div class="col color-gray-6 font-weight-bold font-14">
            {{ ageGroup(item) }}
          </div>
          <div class="col text-black font-14">{{ grantNumber(item) }}</div>
          <div class="col text-black font-14">Evaluación</div>
          <div class="col color-green-money font-weight-bold font-14">
            {{ item.amount }}
          </div>
          <div class="col text-black font-14">
            {{ amountPerAgeGroup(data.tapRequestDistribution) }}
          </div>
        </div>
      </div>

      <div class="visit mb-2">
        <div
          v-for="(item, index) in data.visitDistribution"
          :key="`visit-distribution-detail-${index}`"
          class="visit-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
        >
          <div class="col color-gray-6 font-weight-bold font-14">
            {{ ageGroup(item) }}
          </div>
          <div class="col text-black font-14">{{ grantNumber(item) }}</div>
          <div class="col text-black font-14">Terapia</div>
          <div class="col color-green-money font-weight-bold font-14">
            {{ item.amount }}
          </div>
          <div class="col text-black font-14">
            {{ amountPerAgeGroup(data.visitDistribution) }}
          </div>
        </div>
      </div>

      <div class="consulting">
        <div
          v-for="(item, index) in data.consultingDistribution"
          :key="`consulting-distribution-detail-${index}`"
          class="consulting-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
        >
          <div class="col color-gray-6 font-weight-bold font-14">
            {{ ageGroup(item) }}
          </div>
          <div class="col text-black font-14">{{ grantNumber(item) }}</div>
          <div class="col text-black font-14">Consultoría</div>
          <div class="col color-green-money font-weight-bold font-14">
            {{ item.amount }}
          </div>
          <div class="col text-black font-14">
            {{ amountPerAgeGroup(data.consultingDistribution) }}
          </div>
        </div>
      </div>

      <div
        class="distribution-total row mx-auto col-12 bg-green mt-2 py-3 px-4 rounded"
      >
        <div class="col text-white font-weight-bold font-14">Total</div>
        <div class="col">&nbsp;</div>
        <div class="col">&nbsp;</div>
        <div class="col text-white font-weight-bold font-14">
          {{ totalDistributionAmount }}
        </div>
        <div class="col text-white font-weight-bold font-14">
          {{ totalDistributionAmount }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from 'ActionButton';
import IconView from 'icon-view';

export default {
  name: 'BillingDistributionDetails',
  components: {
    ActionButton,
    IconView,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ageGroup() {
      return (item) => item.ageGroup ?? 'No Disponible';
    },
    grantNumber() {
      return (item) => item.grantNumber ?? 'Por Asignar';
    },
    amountPerAgeGroup() {
      return (serviceDistributionGroup) => {
        const groupAmounts = serviceDistributionGroup.map(
          (item) => item.amount
        );
        return groupAmounts.reduce((pv, cv) => pv + cv, 0);
      };
    },
    totalDistributionAmount() {
      const distributions = this.data.appointmentDistribution.concat(
        this.data.consultingDistribution,
        this.data.planDistribution,
        this.data.tapRequestDistribution,
        this.data.visitDistribution
      );
      const groupAmounts = distributions.map((item) => item.amount);
      return groupAmounts.reduce((pv, cv) => pv + cv, 0);
    },
  },
  methods: {
    onCloseDistributionDetailsButton() {
      this.$emit('on-close', false);
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.distribution-detail > .dot) {
  width: 32px;
  height: 32px;
}
:deep(.distribution-detail > .dot > em) {
  margin: 0% !important;
}
.distribution-card {
  position: relative;
}
.close-icon {
  position: absolute;
  top: 0.5rem;
  right: 0rem;
  z-index: 1;
}
</style>
